import client from './client'
import type { SwapInfo, SwapLog, LiquidityLog } from '@/types'

interface ApiResponse<T> {
  code: number
  data: T
}

export async function getSwapLog(params: { account: string; page?: number; size?: number }) {
  const result = await client.post<unknown, ApiResponse<SwapLog[]>>('/swap/swapHistory', params)
  return { status: !result.code, data: result.data }
}

export async function getLiquidityLog(params: { account: string; page?: number; size?: number }) {
  const result = await client.post<unknown, ApiResponse<LiquidityLog[]>>('/swap/liquidityHistory', params)
  return { status: !result.code, data: result.data }
}

export async function getSwap24HInfo() {
  const result = await client.get<unknown, ApiResponse<SwapInfo>>('/swap/getSwapInfo')
  return { status: !result.code, data: result.data }
}
